import { render, staticRenderFns } from "./PprHf.vue?vue&type=template&id=08ff6ee7"
import script from "./PprHf.vue?vue&type=script&lang=js"
export * from "./PprHf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports